module.exports = __webpack_public_path__ + "static/media/gefactureerd_color.0a5fb98f.svg";